// Словарь раздела НЕ регистрируется здесь: ресурсы собирает `lib/i18n.ts`
// обходом каталога `locales/`. Раньше файл импортировал `ru`- и `en`-JSON и
// звал `addResourceBundle` на оба — при 21 локали (Д11) это означало бы 21
// импорт в каждом из тринадцати таких модулей и локаль, добавленную в
// репозиторий, но забытую в половине из них.

import { useTranslation } from "react-i18next";
import { useLocale } from "@/lib/locale";

/** Namespace экранов входа. */
export const SIGNIN_NS = "signin";

/** Единственная точка доступа к текстам входа. */
export function useSigninT() {
	return useTranslation(SIGNIN_NS).t;
}

/**
 * Текущая локаль в виде кода ISO 639-1 — ровно в том формате, который ждут
 * контракты (`LocaleSchema`, TEXT из двух букв). Реализация одна на все экраны
 * входа (`lib/locale.ts`), здесь только привычное для фичи имя.
 */
export const useSigninLocale = useLocale;
